import React, {useState} from 'react';
//material
import {Button, Card, CardContent, Grid, TextField, withStyles} from '@material-ui/core';
//styles
import styles from './handicap-card-styles';

const HandicapCardView = (props) => {
  const {classes, setIsEdit, isLoading, details} = props;

  return (
    <Card>
      <CardContent>
        <Grid container className={classes.displayTitle} spacing={2}>
          <Grid item>Handicap</Grid>
          <Grid item>
            <Button
              color={'primary'}
              size={'small'}
              variant={'contained'}
              onClick={() => setIsEdit(true)}>
              Edit
            </Button>
          </Grid>
        </Grid>
        {
          !isLoading &&
          <Grid container className={classes.displayBody} spacing={2}>
            <Grid item xs={12}>
              {
                !details.isOfficialHandicap &&
                <Grid container spacing={2}>
                  <Grid item>Handicap :</Grid>
                  <Grid item>
                    {details.handicap ? details.handicap : 0}
                  </Grid>
                </Grid>
              }

              {
                details.isOfficialHandicap &&
                  <>
                    <Grid container spacing={2}>
                      <Grid item>Handicap Index :</Grid>
                      <Grid item>
                        {details.handicapIndex}
                      </Grid>
                    </Grid>

                    <Grid container spacing={2}>
                      <Grid item>CDH Number :</Grid>
                      <Grid item>
                        {details.handicapNumber}
                      </Grid>
                    </Grid>
                  </>
              }
            </Grid>
          </Grid>
        }
      </CardContent>
    </Card>
  );
};

export default withStyles(styles) (HandicapCardView);
